import { Task_Status_Enum } from '@gql'
import { MeetingStepDataTasks } from '@rolebase/shared/model/meeting_step'
import { TasksViewTypes } from '@rolebase/shared/model/task'

type TasksStepData = Pick<
  MeetingStepDataTasks,
  'filterStatus' | 'filterMemberId' | 'reviewMode'
> & { viewType?: TasksViewTypes }

interface TasksStepHandlers {
  onViewChange(view: TasksViewTypes): void
  onMemberChange(memberId: string | undefined): void
  onStatusChange(status: Task_Status_Enum | undefined): void
}

export interface TasksStepModule extends Partial<TasksStepHandlers> {
  view: TasksViewTypes
  readOnly: boolean
  memberId?: string
  status?: Task_Status_Enum
}

// What the Projects step shows of the projects module, and what it lets do.
// Undefined: no projects module (the Texts review mode).
//
// Once the meeting has ended, the projects stay in sight as they are now,
// read-only (#174, Yohan 10/10/2026: the current state, no snapshot is kept).
// The view stays as saved; the filters are dropped rather than hidden while
// still applied, which would hide projects without saying so. Nothing writes
// to the step of a closed meeting.
export function getTasksStepModule(
  data: TasksStepData,
  isEnded: boolean,
  handlers: TasksStepHandlers
): TasksStepModule | undefined {
  if ((data.reviewMode ?? 'Projects') !== 'Projects') return undefined
  const view = data.viewType || TasksViewTypes.Kanban
  if (isEnded) return { view, readOnly: true }
  return {
    view,
    readOnly: false,
    memberId: data.filterMemberId || undefined,
    status: data.filterStatus || undefined,
    ...handlers,
  }
}
